export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['center', 'minTopPadding'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignCenter', 'noMargin'],
                component1: {
                  type: 'header-full',
                  data: {
                    blockModifiers: ['noPadding', 'mediumWeight', 'smallerFontSize'],
                    text: 'Turn your content into friction-free shopping experiences',
                    textMobile: 'Turn your content into friction-free shopping experiences',
                    links: [
                      {
                        linkText: 'Create your free account and get started with Spotin',
                        // linkSubText: '',
                        callback: 'openGetStartedMenu',
                        icon: 'arrow_right_12px',
                      },
                    ]
                  }
                },
                component3: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['mobileNegativeYOffset'],
                    loop: true,
                    autoplay: true,
                    src: "Publisher_page_header_animation_noMasks.json",
                  }
                }
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                headerSize: 'large',
                // header1: 'Spotin for<br>publishers &<br>content makers',
                header2: 'Monetize your content. On your terms.',
                text2: "<p>More than ever, convenience is the key to success on the digital market. Being in the right place, in the right moment, offering consumer experience with the least friction.</p><p>Spotin brings friction-free shopping experiences in any online content, by enabling checkout on the spot - without links or redirections. Your visitors complete the purchase without leaving your site meaning they stay longer on your content.</p><p>Spotin makes it possible for your visitors to buy products (or services) directly from brands and sellers that you chose, and that fits your audience. You can focus on creating engaging content while getting a commission on each sale.</p><p>No need for having an e-commerce platform, integrations, payment provider integrations, or the risk of keeping products on stock, or handling returns for content makers.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: 'A commercial layer on top of your online content.',
                text2: "Spotin provides a high converting commercial layer to any type of editorial content for quick and easy checkout. Spotin features a variety of ways to add commerce to your content (with the <a style='text-decoration: underline;' href='/commercemanager'>Spotin Commerce Manager</a>), while providing added value to your readers.",
              }
            },
            bottom: {
              component: 'video-full',
              data: {
                showSlider: true,
                blockModifiers: ['sideMargins'],
                src: 'desktop_spot.mp4',
                srcMobile: 'mobile_spot.mp4',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                blockModifiers: ['endMargin'],
                header2: 'Keep your audience.',
                text2: "<p>One of the biggest challenges for any publisher or content creator today is keeping the audience and keeping the audience engaged with the content. Until now digital services and digital business models have been centered around traffic and on redirecting visitors somewhere else.</p><p>Working with Spotin and content commerce basically means that you can keep your readers on your site while providing the service of editorial shopping to your site visitors. Focus on and monetize your great content - not the click-based traffic to and from your site.</p>",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                headerSize: 'large',
                // columns: 3,
                blockModifiers: ['endMargin','sideMargins','justifyCenter','alignColumnCenter','noMaxWidth'],
                header2: '”To work with Spotin is really a true delight. I have seldomly met a more dedicated team that really engages themselves in building a common business. Besides that their technical competence is really high. Challenges are solved quickly and efficiently and needed development and adaptations in the tool goes from wishes to completed solution sometimes within a matter of hours.<br><br>For us at Bonnier Spotin has in short time developed to be a key-partner in our business development.”',
                text2: '<strong>Anders Larsson</strong><br>Head of Consumer Sales, Bonnierförlagen',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                header1: 'The Swiss-army-knife of e-commerce',
                text2: "Our features are built to synergize and enable commerce. From adding shoppability to highlighted products to cross-sell, by seamless access to complete product cataloges.",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Spots",
                text2: "Spots make all products discovered in an image buyable. Spots are direct access sales channels to brands. This means that just by clicking on a Spot you are given all the info needed (directly from the seller) to shop right on the spot.</p><p>A single image can contain several spots, also from different brands.",
                link2: {
                  linkText: 'Know more',
                  route: 'incontent',
                },
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['noColumnMargin','maxWidth500'],
                img2: {
                  blockModifiers: ['noMargin'],
                  src: 'Stina_goya_scarf_hat.jpg',
                  alt: 'Spots demo image',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Buy buttons",
                text2: "Buy buttons makes any content into an image-based sales channel and are suitable for pictures displaying one particular item and enables purchases with one quick and effortless checkout.",
                link2: {
                  linkText: 'Know more',
                  route: 'incontent',
                },
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['noColumnMargin','maxWidth500'],
                img2: {
                  blockModifiers: ['noMargin'],
                  src: 'little_liffner_TALL_TULIP TOTE_DUSTY_PINK.png',
                  alt: 'Buy button demo image',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Your curated shop",
                text2: "<p>To create your shop you just need to select the brands that works well with your audience. Spotin then automatically create the store for you and keep this up to date. Does this mean even the tiniest little blog could become a warehouse curated to fit your audience? Oh yes, it does!</p><p>In the Shop you can easily highlight products and brands using a variety of predefined templates and modules with the click of a button. And you can setup your shop directly within your content. Your shop will have the full product catalog from the brands' you chose to work with. Always everything, always the latest within the publisher's content.</p><p>The shop complements the Spots and Buy buttons and enables related sales without customers having to leave your content.</p><p>The Shop also allows for connecting in the editorial content with new drops, collections, campaigns, and events - all leading to a boost in revenues for you and collaborating brands.</p>",
                link2: {
                  linkText: 'Know more',
                  route: 'shop',
                },
              }
            },
            bottom: {
              component: 'video-full',
              data: {
                columns: 3,
                showSlider: true,
                blockModifiers: ['sideMargins', 'endMargin'],
                src: 'desktop_shop.mp4',
                srcMobile: 'mobile_shop.mp4',
              }
            }
          }
        ]
      },
    },


    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offBlackOnOffWhite',
    //     blockModifiers: ['centerBottom'],
    //     sections: [
    //       {
    //         top: {
    //           component: 'flex-block',
    //           data: {
    //             columns: 2,
    //             header2: "Customisable product display",
    //             text2: "<p>Select how to display product pages in different layouts using our templates. Select between side panel view for keeping the background content on screen or full size for a more full on e-com experience.</p>",
    //           }
    //         },
    //         bottom: {
    //           component: 'video-full',
    //           data: {
    //             columns: 3,
    //             showSlider: true,
    //             blockModifiers: ['sideMargins', 'endMargin'],
    //             src: 'desktop_shop.mp4',
    //             srcMobile: 'desktop_spot.mp4',
    //             // srcMobile: 'mobile_shop.mp4',
    //             labels: ['Side panel', 'Full width']
    //           }
    //         }
    //       }
    //     ]
    //   },
    // },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Customisable product display",
                text2: "<p>Select how to display product pages in different layouts using our templates. Select between side panel view for keeping the background content on screen or full size for a more full on e-com experience.</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['center','minTopPadding'],
        sections: [
          {
            full: {
              component: 'flex-block',
              columns: 2,
              data: {
                blockModifiers: ['alignCenter','endMargin'],
                component1: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "product_page_full_width_Desktop.json",
                    caption: 'Full width' 
                  }
                },
                component3: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "product_page_side_panel_Desktop.json",
                    caption: 'Side panel'      
                  }
                }
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        // blockModifiers: [],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header1: 'Manage all your commerce needs in Spotin Portal',
                text2: "<p>Designed exclusively for sellers and content makers, <a style='text-decoration: underline;' href='/portal'>Spotin Portal</a> is your gateway to finding new partnerships, agreeing on commissions, managing existing collaborations, setting up campaigns, analysing the performance and supercharging your content commerce.</p>",
                link2: {
                  linkText: 'Know more',
                  route: 'portal',
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['alignColumnCenter'],
                component2: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    blockModifiers: ['endMargin'],
                    src: "portal_dashboard.json",
                  }
                }
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['alignColumnCenter'],
                component2: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['endMargin'],
                    // src: "Super_simple_integration.json",
                    src: "SuperSimpleIntegration_onscroll.json",
                  }
                }
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Commerce on the<br>terms of brands,<br>content makers and<br>people.',
                text2: "<p>Through this new type of commerce provided by Spotin brands can distribute their sales and create new sales channels. Brands can give their products increased exposure and availability in the ideal context. Spotin also presents a way of meeting customers when the buying interest is at its highest. For the brands this means higher conversion rates and with a holistic view from discovery to purchase the impact of campaigns are measurable in actual sales.</p><p>At the same time, content creators can keep visitors on their content instead of sending them somewhere else with links. With Spotin content makers get a commission on the sales they generate with their content through revenue sharing so that they can keep creating engaging content. At the same time they can offer visitors additional value by providing product information, the convenience to buy directly within their content, and to discover products related to the content.</p><p>With content commerce people get to discover brands and products within the content, instead of searching. They get all the info they need to buy on the spot, directly from brands. Customers can add products from different brands to their shopping bag and complete the order in one single checkout. In short, a much more convenient experience.</p>",
              }
            },
            bottom: {
              component: 'image-block',
              data: {
                blockModifiers: ['sideMargins'],
                src: "venn_content_commerce.svg",
                srcMobile: "venn_content_commerce_mobile.svg",
                alt: "Brands / Content makers / People venn diagram",
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Related'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'Commerce Manager',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'commercemanager',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin Portal',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'portal',
                  },
                  // {
                  //   icon: 'arrowUpRight',
                  //   label: 'Spotin for<br>brands & sellers',
                  //   blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                  //   path: 'sellers',
                  // },
                  {
                    icon: 'arrowUpRight',
                    label: 'What is<br>content commerce?',
                    blockModifiers: ['offWhiteOnBlue','alignLabelLeft', 'alignLabelTop'],
                    path: 'contentcommerce',
                  },
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Publishers.js